import { ETextSize } from '@/components/atoms/at-text/at-text.types';
import { EClickableTypes } from '@/components/atoms/at-clickable/at-clickable.types';
import { ITmModelHomeDetailCSProps } from './tm-model-home-detail.types';
import { EThemes } from '@/lib/contentstack-sdk/types';
import { EImagePosition } from '@/components/atoms/at-media/at-media.types';
import { IHousePlanHit, IStudioHit } from '@/lib/search/types';

export const additionalModelsMock = [
  {
    indexName: 'dev_house_plans_elevations',
    Depth: 52,
    ExteriorStyle: {
      Id: 2,
      Name: 'Craftsman',
    },
    FloorPlans: [
      {
        BasePrice: 441327,
        ElevationId: 288,
        FloorPlanImages: [
          {
            FileName:
              'https://static.schumacherhomes.com/public/assets/floorplanimages/OLIVIA-CLASSIC-FIRST-FLOOR_MW.jpg',
            Type: 'Main Story',
            TypeId: 1,
          },
          {
            FileName:
              'https://static.schumacherhomes.com/public/assets/floorplanimages/OLIVIA-CLASSIC-SECOND-FLOOR.jpg',
            Type: 'Second Story',
            TypeId: 2,
          },
          {
            FileName:
              'https://static.schumacherhomes.com/public/assets/floorplanimages/OLIVIA_DELUXE-OWNERS-BATH-6FT_MW.jpg',
            Type: 'Design Idea',
            TypeId: 5,
          },
          {
            FileName:
              'https://static.schumacherhomes.com/public/assets/floorplanimages/OLIVIA_LAUNDRY-PANTRY-OPTION_MW.jpg',
            Type: 'Design Idea',
            TypeId: 5,
          },
          {
            FileName:
              'https://static.schumacherhomes.com/public/assets/floorplanimages/OLIVIA_MEDIA-ROOM-OPTION_MW.jpg',
            Type: 'Design Idea',
            TypeId: 5,
          },
          {
            FileName:
              'https://static.schumacherhomes.com/public/assets/floorplanimages/OLIVIA-CLASSIC-GRAND-KITCHEN-W-CASEMENT_MW.jpg',
            Type: 'Design Idea',
            TypeId: 5,
          },
          {
            FileName:
              'https://static.schumacherhomes.com/public/assets/floorplanimages/OLIVIA-4TH-BEDROOM-IN-PLACE-OF-LOFT.jpg',
            Type: 'Design Idea',
            TypeId: 5,
          },
        ],
        HasModelHome: true,
        Id: 6358,
        IsPopular: true,
        IsPreferred: true,
        PlanId: 77,
        PopularRank: 2,

        StudioId: 3,
      },
    ],
    Id: 288,
    Image:
      'https://static.schumacherhomes.com/public/assets/homes/rolivia_craftsman.jpg',
    IsBaseElevation: false,
    IsPopular: false,
    IsPreferred: false,
    Name: 'Olivia Craftsman',
    PopularRank: 0,
    SquareFeet: 2786,
    Width: 50,
    HasFloorPlans: true,
    Plan: {
      Bathrooms: 2,
      Bedrooms: 3,
      Collection: null,
      FlexRoom: true,
      FlexRoomIsBedroom: false,
      HasGarage: true,
      Id: 77,
      IsMultiGen: false,
      Name: 'Olivia',
      SimilarPlans: [
        {
          SimilarPlanId: 63,
        },
        {
          SimilarPlanId: 136,
        },
        {
          SimilarPlanId: 140,
        },
      ],
      Stories: [
        {
          Id: 4,
          Name: "2 Story Owner's Retreat Down",
        },
      ],
    },
    objectID: '77_288_3',
  },
] as IHousePlanHit[];

export const mockStudio = {
  indexName: 'dev_design_studios',
  Address: '182 West Hamlin Rd.',
  City: 'Benson',
  Id: 9,
  IsDigital: false,
  IsVirtual: false,
  Name: 'Raleigh-Durham',
  ParentId: null,
  State: 'NC',
  States: [
    {
      Counties: [
        {
          Id: 36,
          InternalName: 'Beaufort',
          Name: 'Beaufort',
          WebActive: false,
        },
        {
          Id: 92,
          InternalName: 'Caswell (Durham office)',
          Name: 'Caswell ',
          WebActive: false,
        },
        {
          Id: 100,
          InternalName: 'Chatham',
          Name: 'Chatham',
          WebActive: true,
        },
        {
          Id: 134,
          InternalName: 'Cumberland',
          Name: 'Cumberland',
          WebActive: true,
        },
        {
          Id: 152,
          InternalName: 'Duplin (sold from Raleigh-Durham)',
          Name: 'Duplin ',
          WebActive: false,
        },
        {
          Id: 153,
          InternalName: 'Durham',
          Name: 'Durham',
          WebActive: true,
        },
        {
          Id: 156,
          InternalName: 'Edgecombe',
          Name: 'Edgecombe',
          WebActive: true,
        },
        {
          Id: 176,
          InternalName: 'Forsyth',
          Name: 'Forsyth',
          WebActive: false,
        },
        {
          Id: 182,
          InternalName: 'Franklin',
          Name: 'Franklin',
          WebActive: true,
        },
        {
          Id: 200,
          InternalName: 'Granville',
          Name: 'Granville',
          WebActive: true,
        },
        {
          Id: 202,
          InternalName: 'Greene',
          Name: 'Greene',
          WebActive: true,
        },
        {
          Id: 215,
          InternalName: 'Halifax (Durham office)',
          Name: 'Halifax ',
          WebActive: true,
        },
        {
          Id: 226,
          InternalName: 'Harnett',
          Name: 'Harnett',
          WebActive: true,
        },
        {
          Id: 241,
          InternalName: 'Hertford',
          Name: 'Hertford',
          WebActive: false,
        },
        {
          Id: 245,
          InternalName: 'Hoke',
          Name: 'Hoke',
          WebActive: true,
        },
        {
          Id: 280,
          InternalName: 'Johnston',
          Name: 'Johnston',
          WebActive: true,
        },
        {
          Id: 298,
          InternalName: 'Lee',
          Name: 'Lee',
          WebActive: true,
        },
        {
          Id: 301,
          InternalName: 'Lenoir',
          Name: 'Lenoir',
          WebActive: true,
        },
        {
          Id: 334,
          InternalName: 'Martin',
          Name: 'Martin',
          WebActive: true,
        },
        {
          Id: 368,
          InternalName: 'Nash',
          Name: 'Nash',
          WebActive: true,
        },
        {
          Id: 379,
          InternalName: 'Northampton',
          Name: 'Northampton',
          WebActive: true,
        },
        {
          Id: 385,
          InternalName: 'Orange',
          Name: 'Orange',
          WebActive: true,
        },
        {
          Id: 400,
          InternalName: 'Person',
          Name: 'Person',
          WebActive: true,
        },
        {
          Id: 405,
          InternalName: 'Pitt',
          Name: 'Pitt',
          WebActive: true,
        },
        {
          Id: 446,
          InternalName: 'Sampson',
          Name: 'Sampson',
          WebActive: true,
        },
        {
          Id: 508,
          InternalName: 'Vance',
          Name: 'Vance',
          WebActive: true,
        },
        {
          Id: 516,
          InternalName: 'Wake',
          Name: 'Wake',
          WebActive: true,
        },
        {
          Id: 520,
          InternalName: 'Warren',
          Name: 'Warren',
          WebActive: true,
        },
        {
          Id: 534,
          InternalName: 'Wayne',
          Name: 'Wayne',
          WebActive: true,
        },
        {
          Id: 549,
          InternalName: 'Wilson',
          Name: 'Wilson',
          WebActive: true,
        },
      ],
      Id: 8,
      Name: 'NC',
    },
    {
      Id: 14,
      Name: 'VA',
    },
  ],
  Zip: '27504',
  objectID: '9',
} as IStudioHit;

export const mockFloorplans = [
  {
    title: 'Main Plan',
    subtitle: 'FIRST FLOOR',
    image: {
      alt: 'Main Plan',
      src: {
        mobile: '/assets/home-plan-elevation-1.svg',
        tablet: '/assets/home-plan-elevation-1.svg',
        desktop: '/assets/home-plan-elevation-1.svg',
      },
    },
  },
  {
    title: 'Secondary Plan',
    subtitle: 'SECOND FLOOR',
    image: {
      alt: 'Secondary Plan',
      src: {
        mobile: '/assets/home-plan-elevation-2.svg',
        tablet: '/assets/home-plan-elevation-2.svg',
        desktop: '/assets/home-plan-elevation-2.svg',
      },
    },
  },
  {
    title: 'Tertiary Plan',
    subtitle: 'Basement',
    image: {
      alt: 'Tertiary Plan',
      src: {
        mobile: '/assets/home-plan-elevation-3.svg',
        tablet: '/assets/home-plan-elevation-3.svg',
        desktop: '/assets/home-plan-elevation-3.svg',
      },
    },
  },
  {
    title: 'Quarterly Plan',
    subtitle: 'Storage',
    image: {
      alt: 'Storage',
      src: {
        mobile: '/assets/home-plan-elevation-4.svg',
        tablet: '/assets/home-plan-elevation-4.svg',
        desktop: '/assets/home-plan-elevation-4.svg',
      },
    },
  },
];

export const tmModelHomeDetailMockData = {
  _content_type_uid: 'tm_model_home_detail',
  uid: 'bltfbc828e333da89ec',
  title: 'Model Home Olivia - Ravina',
  model_home_address: 'XXXX',
  model_home_name: 'Raveena Olivia',
  model_home_id: { model_id: '77' },
  studio_id: { location: ['3'] },
  phone_number: '(555) 555 5555',
  schedule_link: '/',
  hours: [
    {
      dates: {
        days: 'Mon, Wed, Fri',
        _metadata: {
          uid: 'cs4e6e25c24018af2e',
        },
        hours: '9am-6pm',
      },
    },
    {
      dates: {
        days: 'Tue, Thu',
        _metadata: {
          uid: 'csf0370f36bcdf1363',
        },
        hours: '10am-8pm',
      },
    },
  ],
  hero_gallery: [
    {
      global_field: {
        priority: false,
        decorative: true,
        quality: '70',
        mobile_image_url: {
          uid: 'blt15020674fc4e5339',
          created_by: 'blt8dcc408130de2249',
          updated_by: 'blt8dcc408130de2249',
          created_at: '2025-03-10T17:19:18.230Z',
          updated_at: '2025-03-10T17:19:18.230Z',
          content_type: 'image/jpeg',
          file_size: '232379',
          filename: 'visit_design_center.jpg',
          ACL: {},
          parent_uid: null,
          is_dir: false,
          url: 'https://images.contentstack.io/v3/assets/blte8e7d2bd4f946026/blt15020674fc4e5339/67cf1f163d548789c20eeea2/visit_design_center.jpg?branch=develop',
        },
        mobile_position: 'center',
        mobile_aspect_ratio: 'auto',
        tablet_image_url: null,
        tablet_position: null,
        tablet_aspect_ratio: null,
        desktop_image_url: null,
        desktop_position: 'center',
        desktop_aspect_ratio: null,
      },
      _metadata: {
        uid: 'cs64ea2ebc651a3381',
      },
    },
    {
      global_field: {
        priority: false,
        decorative: true,
        quality: '70',
        mobile_image_url: {
          uid: 'blt26284ac01677a471',
          created_by: 'blt9d38ef245c24d64c',
          updated_by: 'blt9d38ef245c24d64c',
          created_at: '2025-03-18T19:28:42.684Z',
          updated_at: '2025-03-18T19:28:42.684Z',
          content_type: 'image/jpeg',
          file_size: '8195194',
          filename: 'img-2.jpeg',
          ACL: {},
          parent_uid: null,
          is_dir: false,
          publish_details: {
            time: '2025-03-18T19:29:53.885Z',
            user: 'blt9d38ef245c24d64c',
            environment: 'blt901eff50b24bab9c',
            locale: 'en-us',
          },
          url: 'https://images.contentstack.io/v3/assets/blte8e7d2bd4f946026/blt26284ac01677a471/67d9c96a1c7222056243a161/img-2.jpeg?branch=develop',
        },
        mobile_position: 'center',
        mobile_aspect_ratio: 'auto',
        tablet_image_url: null,
        tablet_position: null,
        tablet_aspect_ratio: null,
        desktop_image_url: null,
        desktop_position: 'center',
        desktop_aspect_ratio: null,
      },
      _metadata: {
        uid: 'cs2ffc43a2d3f3dfa4',
      },
    },
  ],
  featured_media: {
    _content_type_uid: 'featured_video',
    title: 'Take a virtual tour',
    description:
      '<p>Peek inside the Charleston - Modern Hill Country Model Home at Columbus North.</p><p></p><p>*Maybe shown with optional features</p>',
    video_url: 'https://www.youtube.com/watch?v=LVnrbp8DPO4',
    top_spacing: { spacing_value: 'md', divider: false },
    bottom_spacing: { spacing_value: 'md', divider: false },
    video_thumbnail: {
      decorative: false,
      desktop_aspect_ratio: null,
      desktop_image_url: null,
      desktop_position: null,
      mobile_aspect_ratio: 'auto',
      mobile_image_url: {
        uid: 'bltad41e69e8f9e9929',
        ACL: {},
        content_type: 'image/png',
        created_at: '2025-02-01T13:43:44.199Z',
        created_by: 'blt8d45334d7e084c9a',
        file_size: '1623766',
        filename: 'test.png',
        is_dir: false,
        parent_uid: null,
        title: 'test.png',
        updated_at: '2025-03-17T15:18:38.357Z',
        updated_by: 'blt81b1cadb0cbd06e9',
        url: 'https://images.contentstack.io/v3/assets/blte8e7d2bd4f946026/bltad41e69e8f9e9929/679e25104405defe114af1fa/test.png?branch=develop',
      },
      mobile_position: 'center',
      priority: false,
      quality: '75',
      tablet_aspect_ratio: null,
      tablet_image_url: null,
      tablet_position: null,
    },
  },
  body: [],
  tags: [],
  locale: 'en-us',
  created_by: 'blt8d45334d7e084c9a',
  updated_by: 'blt8d45334d7e084c9a',
  created_at: '2025-03-16T16:15:11.168Z',
  updated_at: '2025-03-28T00:15:01.828Z',
  ACL: {},
  _version: 16,
  _in_progress: false,
  awards_banner: {
    description: '<p>Best Interior Merchandising</p>',
    heading: '2020 National Gold Winner',
    heading_element: {
      select: 'h2',
    },
    heading_variant: {
      select: 'h2',
    },
    icon: [
      {
        uid: 'bltf5744a6db87366a4',
        locale: 'en-us',
        ACL: {},
        created_at: '2025-03-27T13:11:05.391Z',
        created_by: 'blt8d45334d7e084c9a',
        name: {
          icon: 'trophy',
        },

        size: ETextSize.LG,
        updated_at: '2025-03-27T13:11:54.983Z',
        updated_by: 'blt8d45334d7e084c9a',
      },
    ],
    theme: {
      theme: 'DARK',
    },
    show_banner: true,
    banner_cta: {
      aria_label: '',
      icon: [],
      label: '',
      outline: false,
      size: 'LG',
      target: 'SELF',
      type: EClickableTypes.CTA,
      url: {
        title: '',
        href: '',
      },
      variant: 'PRIMARY',
    },
  },
  directions_link:
    'https://www.google.com/maps/place/Juno+Veterinary+King+West/@43.6338688,-79.4195248,14z/data=!4m6!3m5!1s0x882b35143cf6dccd:0x36889586a1ca6fed!8m2!3d43.6465206!4d-79.4009337!16s%2Fg%2F11vm60n7n7?entry=ttu&g_ep=EgoyMDI1MDMyNC4wIKXMDSoASAFQAw%3D%3D',
  faq: [
    {
      _content_type_uid: 'accordion',
      uid: 'bltf98e8dbb48c9bb29',
      title: 'Model Home FAQ',
      items: [
        {
          accordion_item: {
            title: 'Model Home Question',
            body: '<p>Lorem ipsum</p>',
          },
        },
      ],
      locale: 'en-us',
      created_by: 'blt8d45334d7e084c9a',
      updated_by: 'blt8d45334d7e084c9a',
      created_at: '2025-03-27T13:37:33.395Z',
      updated_at: '2025-03-27T13:37:54.422Z',
      ACL: {},
    },
  ],
  model_details: {
    copy_block: {
      alt_header: false,
      description:
        "<ul><li>This spacious kitchen features ample counter and cabinet space, a large island for gatherings, and a walk-in pantry</li><li>Convenient pocket office provides a dedicated workspace for organization and productivity</li><li>Luxurious Owner's Retreat includes a spacious bathroom, dual walk-in closets, and easy access from the office</li><li>Plenty of private space for everyone in the family</li></ul>",
      heading_element: 'h2',
      heading_variant: 'h1',
      link: {
        aria_label: '',
        icon: [],
        outline: false,
        size: 'LG',
        type: EClickableTypes.CTA,
        label: '',
        target: 'SELF',
        url: {
          title: '',
          href: '',
        },
        variant: 'PRIMARY',
      },
      alignment: { alignmentprop: 'CENTER' },
      _content_type_uid: 'copy_block',
      theme: { theme: EThemes.DARK },
      title: 'About this Model',
    },
  },
  tour_banner: {
    description:
      '<p><strong>Take a self-guided tour:</strong> move through our model home at your own pace</p>',
    heading: '',
    heading_element: {
      select: 'h2',
    },
    heading_variant: {
      select: 'h2',
    },
    icon: [
      {
        uid: 'blt314c997746cc027a',
        locale: 'en-us',
        ACL: {},
        created_at: '2025-03-27T13:36:02.351Z',
        created_by: 'blt8d45334d7e084c9a',
        name: {
          icon: 'camera',
        },
        size: ETextSize.LG,
        updated_at: '2025-03-27T13:36:02.351Z',
        updated_by: 'blt8d45334d7e084c9a',
      },
    ],
    show_banner: true,
    theme: {
      theme: 'LIGHT',
    },
    banner_cta: {
      aria_label: 'Navigate to 3D tour',
      icon: [],
      label: '',
      outline: false,
      size: 'SM',
      target: 'BLANK',
      type: 'cta',
      url: {
        title: 'Launch the Tour',
        href: '/',
      },
      variant: 'PRIMARY',
    },
  },
  book_appointment: {
    copy_block: {
      alt_header: false,
      theme: { theme: EThemes.DARK },
      alignment: { alignmentprop: 'CENTER' },
      _content_type_uid: 'copy_block',
      description:
        '<p>Step inside a <strong>Design Center</strong> or <strong>Model Home </strong>to experience the craftsmanship and get support for\n<br/>your custom home journey.</p>',
      heading_element: 'h2',
      heading_variant: 'h2',
      link: {
        aria_label: '',
        icon: [],
        label: '',
        target: 'BLANK',
        outline: true,
        size: 'SM',
        type: EClickableTypes.CTA,
        url: {
          title: 'Book an appointment',
          href: '/',
        },
        variant: 'PRIMARY',
      },
      title: 'Come see for yourself',
    },
    image: {
      decorative: false,
      desktop_aspect_ratio: null,
      desktop_image_url: null,
      desktop_position: null,
      mobile_aspect_ratio: 'auto',
      mobile_image_url: {
        uid: 'blted3fc3e6eb10a9ed',
        _version: 1,
        title: 'half-page-media-desktop.jpg',
        created_by: 'blt8dcc408130de2249',
        updated_by: 'blt8dcc408130de2249',
        created_at: '2025-03-07T20:26:51.386Z',
        updated_at: '2025-03-07T20:26:51.386Z',
        content_type: 'image/jpeg',
        file_size: '400089',
        filename: 'half-page-media-desktop.jpg',
        ACL: {},
        parent_uid: null,
        is_dir: false,
        url: 'https://images.contentstack.io/v3/assets/blte8e7d2bd4f946026/blted3fc3e6eb10a9ed/67cb568b3661f252beccbc37/half-page-media-desktop.jpg?branch=develop',
      },
      mobile_position: EImagePosition.CENTER,
      priority: false,
      quality: '75',
      tablet_aspect_ratio: null,
      tablet_image_url: null,
      tablet_position: null,
    },
  },
  publish_details: {
    time: '2025-03-28T00:15:09.729Z',
    user: 'blt8d45334d7e084c9a',
    environment: 'blt901eff50b24bab9c',
    locale: 'en-us',
  },
} as ITmModelHomeDetailCSProps;

export const elevationsByIdMock = {
  currentModelData: [
    {
      indexName: 'dev_house_plans_elevations',
      Depth: 52,
      ExteriorStyle: {
        Id: 2,
        Name: 'Craftsman',
      },
      FloorPlans: [
        {
          BasePrice: 441327,
          ElevationId: 288,
          FloorPlanImages: [
            {
              FileName:
                'https://static.schumacherhomes.com/public/assets/floorplanimages/OLIVIA-CLASSIC-FIRST-FLOOR_MW.jpg',
              Type: 'Main Story',
              TypeId: 1,
            },
            {
              FileName:
                'https://static.schumacherhomes.com/public/assets/floorplanimages/OLIVIA-CLASSIC-SECOND-FLOOR.jpg',
              Type: 'Second Story',
              TypeId: 2,
            },
            {
              FileName:
                'https://static.schumacherhomes.com/public/assets/floorplanimages/OLIVIA_DELUXE-OWNERS-BATH-6FT_MW.jpg',
              Type: 'Design Idea',
              TypeId: 5,
            },
            {
              FileName:
                'https://static.schumacherhomes.com/public/assets/floorplanimages/OLIVIA_LAUNDRY-PANTRY-OPTION_MW.jpg',
              Type: 'Design Idea',
              TypeId: 5,
            },
            {
              FileName:
                'https://static.schumacherhomes.com/public/assets/floorplanimages/OLIVIA_MEDIA-ROOM-OPTION_MW.jpg',
              Type: 'Design Idea',
              TypeId: 5,
            },
            {
              FileName:
                'https://static.schumacherhomes.com/public/assets/floorplanimages/OLIVIA-CLASSIC-GRAND-KITCHEN-W-CASEMENT_MW.jpg',
              Type: 'Design Idea',
              TypeId: 5,
            },
            {
              FileName:
                'https://static.schumacherhomes.com/public/assets/floorplanimages/OLIVIA-4TH-BEDROOM-IN-PLACE-OF-LOFT.jpg',
              Type: 'Design Idea',
              TypeId: 5,
            },
          ],
          HasModelHome: true,
          Id: 6358,
          IsPopular: true,
          IsPreferred: true,
          PlanId: 77,
          PopularRank: 2,
          Studio: {
            Address: '4367 State Route 14',
            City: 'Ravenna',
            Id: 3,
            IsDigital: false,
            IsVirtual: false,
            Name: 'Ravenna',
            ParentId: null,
            State: 'OH',
            Zip: '44266',
          },
          StudioId: 3,
        },
      ],
      Id: 288,
      Image:
        'https://static.schumacherhomes.com/public/assets/homes/rolivia_craftsman.jpg',
      IsBaseElevation: false,
      IsPopular: false,
      IsPreferred: false,
      Name: 'Olivia Craftsman',
      PopularRank: 0,
      SquareFeet: 2786,
      Width: 50,
      HasFloorPlans: true,
      Plan: {
        Bathrooms: 2,
        Bedrooms: 3,
        Collection: null,
        FlexRoom: true,
        FlexRoomIsBedroom: false,
        HasGarage: true,
        Id: 77,
        IsMultiGen: false,
        Name: 'Olivia',
        SimilarPlans: [
          {
            SimilarPlanId: 63,
          },
          {
            SimilarPlanId: 136,
          },
          {
            SimilarPlanId: 140,
          },
        ],
        Stories: [
          {
            Id: 4,
            Name: "2 Story Owner's Retreat Down",
          },
        ],
      },
      objectID: '77_288_3',
      _highlightResult: {
        FloorPlans: [
          {
            Studio: {
              Address: {
                value: '4367 State Route 14',
                matchLevel: 'none',
                matchedWords: [],
              },
            },
          },
        ],
        Name: {
          value: 'Olivia Craftsman',
          matchLevel: 'none',
          matchedWords: [],
        },
      },
    },
  ],
  additionalModelData: [
    {
      indexName: 'dev_house_plans_elevations',
      Depth: 48,
      ExteriorStyle: {
        Id: 1,
        Name: 'American Tradition',
      },
      FloorPlans: [
        {
          BasePrice: 363797,
          ElevationId: 313,
          FloorPlanImages: [
            {
              FileName:
                'https://static.schumacherhomes.com/public/assets/floorplanimages/SANTA-BARBARA-MAIN-FLOOR_MW.jpg',
              Type: 'Main Story',
              TypeId: 1,
            },
            {
              FileName:
                'https://static.schumacherhomes.com/public/assets/floorplanimages/SANTA-BARBARA_OWNERS-DELUXE-BATH---NO-TUB_MW.jpg',
              Type: 'Design Idea',
              TypeId: 5,
            },
            {
              FileName:
                'https://static.schumacherhomes.com/public/assets/floorplanimages/SANTA-BARBARA_OWNERS-TUB-SHOWER_MW.jpg',
              Type: 'Design Idea',
              TypeId: 5,
            },
          ],
          HasModelHome: true,
          Id: 7016,
          IsPopular: true,
          IsPreferred: false,
          PlanId: 85,
          PopularRank: 1,
          Studio: {
            Address: '4367 State Route 14',
            City: 'Ravenna',
            Id: 3,
            IsDigital: false,
            IsVirtual: false,
            Name: 'Ravenna',
            ParentId: null,
            State: 'OH',
            Zip: '44266',
          },
          StudioId: 3,
        },
      ],
      Id: 313,
      Image:
        'https://static.schumacherhomes.com/public/assets/homes/rsanta-barbara_americantradition.jpg',
      IsBaseElevation: false,
      IsPopular: false,
      IsPreferred: false,
      Name: 'Santa Barbara American Tradition',
      PopularRank: 0,
      SquareFeet: 1917,
      Width: 64,
      HasFloorPlans: true,
      Plan: {
        Bathrooms: 2,
        Bedrooms: 3,
        Collection: null,
        FlexRoom: true,
        FlexRoomIsBedroom: false,
        HasGarage: true,
        Id: 85,
        IsMultiGen: false,
        Name: 'Santa Barbara',
        SimilarPlans: [
          {
            SimilarPlanId: 2,
          },
          {
            SimilarPlanId: 15,
          },
          {
            SimilarPlanId: 17,
          },
        ],
        Stories: [
          {
            Id: 1,
            Name: '1 Story',
          },
        ],
      },
      objectID: '85_313_3',
      _highlightResult: {
        FloorPlans: [
          {
            Studio: {
              Address: {
                value: '4367 State Route 14',
                matchLevel: 'none',
                matchedWords: [],
              },
            },
          },
        ],
        Name: {
          value: 'Santa Barbara American Tradition',
          matchLevel: 'none',
          matchedWords: [],
        },
      },
    },
    {
      indexName: 'dev_house_plans_elevations',
      Depth: 62,
      ExteriorStyle: {
        Id: 10,
        Name: 'Modern Hill Country',
      },
      FloorPlans: [
        {
          BasePrice: 506309,
          ElevationId: 610,
          FloorPlanImages: [
            {
              FileName:
                'https://static.schumacherhomes.com/public/assets/floorplanimages/CHARLESTON-II_FIRST-FLOOR_MW.jpg',
              Type: 'Main Story',
              TypeId: 1,
            },
            {
              FileName:
                'https://static.schumacherhomes.com/public/assets/floorplanimages/rCHARLESTON-II_MULTIGEN_CAR.jpg',
              Type: 'Design Idea',
              TypeId: 5,
            },
          ],
          HasModelHome: true,
          Id: 8872,
          IsPopular: true,
          IsPreferred: true,
          PlanId: 133,
          PopularRank: 7,
          Studio: {
            Address: '4367 State Route 14',
            City: 'Ravenna',
            Id: 3,
            IsDigital: false,
            IsVirtual: false,
            Name: 'Ravenna',
            ParentId: null,
            State: 'OH',
            Zip: '44266',
          },
          StudioId: 3,
        },
      ],
      Id: 610,
      Image:
        'https://static.schumacherhomes.com/public/assets/homes/twilight-ext-new_ravenna-charleston-ii.jpg',
      IsBaseElevation: false,
      IsPopular: false,
      IsPreferred: false,
      Name: 'Charleston II Modern Hill Country',
      PopularRank: 0,
      SquareFeet: 2833,
      Width: 70,
      HasFloorPlans: true,
      Plan: {
        Bathrooms: 2,
        Bedrooms: 4,
        Collection: null,
        FlexRoom: true,
        FlexRoomIsBedroom: true,
        HasGarage: true,
        Id: 133,
        IsMultiGen: true,
        Name: 'Charleston II',
        SimilarPlans: [
          {
            SimilarPlanId: 31,
          },
          {
            SimilarPlanId: 167,
          },
          {
            SimilarPlanId: 171,
          },
        ],
        Stories: [
          {
            Id: 1,
            Name: '1 Story',
          },
          {
            Id: 7,
            Name: "Dual Owner's Retreat",
          },
        ],
      },
      objectID: '133_610_3',
      _highlightResult: {
        FloorPlans: [
          {
            Studio: {
              Address: {
                value: '4367 State Route 14',
                matchLevel: 'none',
                matchedWords: [],
              },
            },
          },
        ],
        Name: {
          value: 'Charleston II Modern Hill Country',
          matchLevel: 'none',
          matchedWords: [],
        },
      },
    },
  ],
};
